var DB_Footer_Arguments = {
    init:function(){
        window.addEventListener("resize", function(){
            DB_Footer_Arguments.resize();
        });
        DB_Footer_Arguments.resize();
    },
    resize:function(){
        var _container_w = document.querySelector(".DB-footer-arguments .arguments-list").offsetWidth ;
        var _content_w = document.querySelector(".DB-footer-arguments .arguments-content").offsetWidth ;
        
        if(_container_w < _content_w){
            document.querySelector(".DB-footer-arguments").classList.add("animated");
        }else{
            document.querySelector(".DB-footer-arguments").classList.remove("animated");
        }
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-footer-arguments").length > 0){
        DB_Footer_Arguments.init();
    }
})